import Image from "next/image";
import { useEffect, useState } from "react";
import SwiperCore, { Navigation, Thumbs } from "swiper";
import "swiper/css/thumbs";
import { Swiper, SwiperSlide } from "swiper/react";

SwiperCore.use([Navigation, Thumbs]);

const ThumbSlider = ({ product }) => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <>
      <Swiper
        style={{
          "--swiper-navigation-color": "#ececec",
          "--swiper-pagination-color": "#fff",
        }}
        navigation={true}
        thumbs={{
          swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
        }}
        className="mySwiper2"
      >
        <SwiperSlide>
          <div className="mainImg">
            <img src={product.main_image || "/assets/imgs/theme/logo.png"} />
          </div>
        </SwiperSlide>
        {product.sub_image?.map((item, i) => (
          <SwiperSlide key={i}>
            <div className="mainImg">
              <img src={item} />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        slidesPerView={4}
        spaceBetween={20}
        freeMode={true}
        watchSlidesProgress={true}
        slideToClickedSlide={true}
        className="mySwiper"
      >
        <SwiperSlide>
          <img className="subImg" src={product.main_image} />
        </SwiperSlide>
        {product.sub_image?.map((item, i) => (
          <SwiperSlide key={i}>
            <img className="subImg" src={item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default ThumbSlider;
